import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import {
  getBootCampFormData,
  updateBootCampFormData,
} from "../../../../utils/pip";

function getDayCount(start_date, end_date) {
  const start = new Date(start_date);
  const end = new Date(end_date);
  if (isNaN(start) || isNaN(end) || end < start) return 0;
  const diffTime = end.getTime() - start.getTime();
  const diffDays = diffTime / (1000 * 60 * 60 * 24);
  return diffDays + 1;
}

const CreateBootCampStep2 = ({
  onClose,
  onHanldeSubmit,
  previousForm,
  isEdit,
  setStep2DayData,
  step2DayData,
}) => {
  const savedData = getBootCampFormData().step1;
  const savedData2 = getBootCampFormData().step2;

  const [dayData, setDayData] = useState(savedData2?.dayData ?? []);

  const [bootCampData, setBootCampData] = useState({
    bootcamp_price: savedData2?.bootCampData?.bootcamp_price,
    bootcamp_seat: savedData2?.bootCampData?.bootcamp_seat,
  });

  useEffect(() => {
    if (!isEdit) {
      if (!savedData?.start_date || !savedData?.end_date) return;
      const totalDays = getDayCount(savedData?.start_date, savedData?.end_date);
      const allDays = Array.from({ length: totalDays }, (_, i) => {
        const date = new Date(savedData.start_date);
        date.setDate(date.getDate() + i);
        const formattedDate = date.toISOString().split("T")[0];
        return {
          day_number: i + 1,
          title: "",
          description: "",
          sessions: [
            {
              description: "",
              title: "",
              date: formattedDate,
              start_time: "",
              speakers: [
                // {
                //   name: "",
                //   role: "",
                //   image: null,
                // },
              ],
            },
          ],
        };
      });
      setDayData(allDays);
    }
  }, [savedData?.start_date, savedData?.end_date]);

  useEffect(() => {
    const savedStep2 = getBootCampFormData().step2;
    if (savedStep2?.dayData?.length > 0) {
      setDayData(savedStep2.dayData);
      setBootCampData(savedStep2.bootCampData);
    }
  }, []);

  const handlesessionsChange = (dayIndex, listIndex, field, value) => {
    setDayData((prev) => {
      const newDayData = [...prev];
      newDayData[dayIndex].sessions[listIndex] = {
        ...newDayData[dayIndex].sessions[listIndex],
        [field]: value,
      };
      return newDayData;
    });
  };

  const handleDayFieldChange = (dayIndex, field, value) => {
    setDayData((prev) => {
      const newDayData = [...prev];
      newDayData[dayIndex] = {
        ...newDayData[dayIndex],
        [field]: value,
      };
      return newDayData;
    });
  };

  const handleSpeakerChange = (
    dayIndex,
    sessionIndex,
    speakerIndex,
    field,
    value
  ) => {
    setDayData((prev) => {
      const newDayData = [...prev];
      newDayData[dayIndex].sessions[sessionIndex].speakers[speakerIndex] = {
        ...newDayData[dayIndex].sessions[sessionIndex].speakers[speakerIndex],
        [field]: value,
      };
      return newDayData;
    });
  };

  const addNewTask = (dayIndex) => {
    setDayData((prev) => {
      return prev.map((day, idx) => {
        if (idx !== dayIndex) return day;
        return {
          ...day,
          sessions: day.sessions.concat({
            title: "",
            description: "",
            date: day.sessions[0].date,
            start_time: "",
            speakers: [
              // {
              //   name: "",
              //   role: "",
              //   image: null,
              // },
            ],
          }),
        };
      });
    });
  };

  const addSpeaker = (dayIndex, sessionIndex) => {
    setDayData((prev) => {
      const newDayData = structuredClone(prev); // deep clone to avoid mutation
      const session = newDayData[dayIndex].sessions[sessionIndex];
      session.speakers = [
        ...(session.speakers || []),
        {
          name: "",
          role: "",
          image: null,
        },
      ];
      return newDayData;
    });
  };

  const deleteTask = (dayIndex, listIndex) => {
    setDayData((prev) => {
      const newDayData = [...prev];
      newDayData[dayIndex].sessions = newDayData[dayIndex].sessions.filter(
        (_, idx) => idx !== listIndex
      );
      return newDayData;
    });
  };

  const deleteSpeaker = (dayIndex, sessionIndex, speakerIndex) => {
    setDayData((prev) => {
      const newDayData = [...prev];
      newDayData[dayIndex].sessions[sessionIndex].speakers = newDayData[
        dayIndex
      ].sessions[sessionIndex].speakers.filter(
        (_, idx) => idx !== speakerIndex
      );
      return newDayData;
    });
  };

  const handleStep2 = () => {
    // Validate bootcamp data
    const isBootcampValid = Object.values(bootCampData).every(
      (val) => val !== "" && val !== null && val !== undefined
    );

    // Validate dayData (days, sessions, and speakers)
    const isDayDataValid = dayData.every((day) => {
      if (!day.title || !day.description) return false;

      return day.sessions.every((session) => {
        if (
          !session.title ||
          !session.description ||
          !session.date ||
          !session.start_time
        )
          return false;

        // ✅ Check each speaker
        if (session.speakers && session.speakers.length > 0) {
          return session.speakers.every((speaker) => {
            return (
              speaker.name &&
              speaker.role &&
              speaker.image !== null &&
              speaker.image !== undefined
            );
          });
        }

        return true; // if no speakers, it's fine
      });
    });

    if (!isBootcampValid || !isDayDataValid) {
      toast.error("Please fill all the required fields before submitting!");
      return;
    }

    // ✅ Before submitting, sanitize image values
    const cleanedDayData = dayData.map((day) => ({
      ...day,
      sessions: day.sessions.map((session) => ({
        ...session,
        speakers:
          session.speakers?.map((speaker) => ({
            ...speaker,
          })) || [],
      })),
    }));

    setStep2DayData(dayData);

    // Prepare final payload
    const values = {
      bootCampData,
      dayData: cleanedDayData,
    };

    // Save both steps
    updateBootCampFormData("step1", savedData);
    updateBootCampFormData("step2", values);
    onHanldeSubmit();
  };

  return (
    <div className="modal d-block modal-lg ct_congratulation_modal_fade">
      <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div class="modal-content ">
          <div class="modal-header border-0">
            <button
              type="button"
              class="btn-close ct_circle_close"
              onClick={onClose}
            ></button>
          </div>
          <div class="modal-body p-0">
            <h4 class="ct_fw_600 mb-1 ct_fs_20 ct_darksky_blue_text px-4">
              {isEdit ? "Update" : "Create"} your event step 2
            </h4>
            <p class="mb-0 ct_grey_text px-4">
              {isEdit ? "Update" : "Create"} and schedule {isEdit ? "" : "new"}{" "}
              events seamlessly.
            </p>
            <form class="mt-4 ct_modal_scroll ct_custom_scroll px-4">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label className="d-block mb-2">Bootcamp Price</label>
                    <input
                      type="number"
                      className="form-control ct_input"
                      placeholder="Bootcamp Price"
                      id="header_title"
                      onChange={(e) =>
                        setBootCampData((prev) => ({
                          ...prev,
                          bootcamp_price: e.target.value,
                        }))
                      }
                      value={bootCampData?.bootcamp_price}
                    />
                    {/* <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={"header_title"}
                                        /> */}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label className="d-block mb-2">Bootcamp Seats</label>
                    <input
                      type="number"
                      className="form-control ct_input"
                      placeholder="Bootcamp Seats"
                      id="header_title"
                      onChange={(e) =>
                        setBootCampData((prev) => ({
                          ...prev,
                          bootcamp_seat: e.target.value,
                        }))
                      }
                      value={bootCampData?.bootcamp_seat}
                    />
                    {/* <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={"header_title"}
                                        /> */}
                  </div>
                </div>
              </div>
              {dayData?.map((item, i) => (
                <div class="pb-4">
                  <div class="d-flex align-items-center gap-2 justify-content-between mb-2">
                    <p class="mb-0 ct_fs_20 ct_fw_600">Day {i + 1}</p>
                  </div>
                  <div class="">
                    <div
                      class="ct_light_grey_bg my-0 "
                      style={{ backgroundColor: "#e7e7e7" }}
                    >
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <textarea
                              rows="2"
                              className="form-control ct_input h-auto"
                              placeholder="Title"
                              value={item?.title}
                              onChange={(e) =>
                                handleDayFieldChange(i, "title", e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <textarea
                              rows="2"
                              className="form-control ct_input h-auto"
                              placeholder="Description"
                              value={item?.description}
                              onChange={(e) =>
                                handleDayFieldChange(
                                  i,
                                  "description",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ct_para_scroll ct_custom_scroll">
                      {item?.sessions?.length != 0 &&
                        item?.sessions?.map((items, index) => (
                          <div
                            class="ct_light_grey_bg my-3"
                            style={{ backgroundColor: "#e7e7e7" }}
                          >
                            <div class="d-flex align-items-center justify-content-end gap-2 mb-2">
                              <div
                                class="ct_bootcamp_action_btn"
                                onClick={() => addNewTask(i)}
                                style={{ backgroundColor: "#ababab45" }}
                              >
                                <i class="fa-solid fa-plus"></i>
                              </div>
                              {index != 0 && (
                                <div
                                  class="ct_bootcamp_action_btn text-white"
                                  onClick={() => deleteTask(i, index)}
                                  style={{ backgroundColor: "#ff0000" }}
                                >
                                  <i class="fa-solid fa-trash-can"></i>
                                </div>
                              )}
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group mb-4">
                                  <textarea
                                    rows="2"
                                    placeholder="Title"
                                    class="form-control ct_input h-auto"
                                    value={items?.title}
                                    onChange={(e) =>
                                      handlesessionsChange(
                                        i,
                                        index,
                                        "title",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group mb-4">
                                  <input
                                    type="date"
                                    class="form-control ct_input"
                                    value={items?.date}
                                    onChange={(e) =>
                                      handlesessionsChange(
                                        i,
                                        index,
                                        "date",
                                        e.target.value
                                      )
                                    }
                                    min={new Date().toISOString().split("T")[0]}
                                  />
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group mb-4">
                                  <input
                                    type="time"
                                    class="form-control ct_input"
                                    value={items?.start_time}
                                    onChange={(e) =>
                                      handlesessionsChange(
                                        i,
                                        index,
                                        "start_time",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group mb-0">
                                  <textarea
                                    placeholder="Description"
                                    class="form-control ct_input h-auto"
                                    rows="3"
                                    value={items?.description}
                                    onChange={(e) =>
                                      handlesessionsChange(
                                        i,
                                        index,
                                        "description",
                                        e.target.value
                                      )
                                    }
                                  ></textarea>
                                </div>
                              </div>
                            </div>

                            {/* Add Speaker  */}
                            <div className="mt-4">
                              <div className="d-flex align-items-center gap-3 justify-content-between  mb-3">
                                <p className="  mb-0 ct_fs_20 ct_fw_600">
                                  Speakers
                                </p>
                                <div
                                  class="ct_bootcamp_action_btn ct_cursor_pointer"
                                  onClick={() => addSpeaker(i, index)}
                                  style={{ backgroundColor: "#ababab45" }}
                                >
                                  <i class="fa-solid fa-plus"></i>
                                </div>
                              </div>
                              {items?.speakers?.map((speaker, spindex) => (
                                <div className="ct_multiple_spealer_bg_light_white mb-3 ">
                                  <div className="d-flex align-items-center gap-3 justify-content-between mb-2">
                                    <h4 className="ct_fs_16 ct_fw_600  mb-0">
                                      Speaker {spindex + 1}
                                    </h4>
                                    <div className="d-flex align-items-center justify-content-end gap-2 mb-2">
                                      <div
                                        class="ct_bootcamp_action_btn text-white ct_cursor_pointer"
                                        onClick={() =>
                                          deleteSpeaker(i, index, spindex)
                                        }
                                        style={{ backgroundColor: "#ff0000" }}
                                      >
                                        <i class="fa-solid fa-trash-can"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row ">
                                    <div className="col-md-6">
                                      <div className="row">
                                        <div class="col-md-12">
                                          <div class="form-group mb-3">
                                            <label for="" class="d-block mb-2">
                                              {" "}
                                              Name
                                            </label>
                                            <textarea
                                              rows="2"
                                              value={speaker.name}
                                              onChange={(e) =>
                                                handleSpeakerChange(
                                                  i,
                                                  index,
                                                  spindex,
                                                  "name",
                                                  e.target.value
                                                )
                                              }
                                              class="form-control ct_input h-auto"
                                              placeholder="Name"
                                            />
                                          </div>
                                        </div>
                                        <div class="col-md-12">
                                          <div class="form-group  mb-3">
                                            <label for="" class="d-block mb-2">
                                              {" "}
                                              Role
                                            </label>
                                            <textarea
                                              rows="2"
                                              value={speaker.role}
                                              onChange={(e) =>
                                                handleSpeakerChange(
                                                  i,
                                                  index,
                                                  spindex,
                                                  "role",
                                                  e.target.value
                                                )
                                              }
                                              class="form-control ct_input h-auto"
                                              placeholder="Role"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="form-group  mb-3">
                                        <label for="" class="d-block mb-2">
                                          Photo
                                        </label>
                                        <div
                                          class={`ct_upload_product_main ct_upload_product_main_180 ${
                                            speaker.image ? "d-none" : ""
                                          }`}
                                          style={{ height: "142px" }}
                                        >
                                          <label>
                                            <p class="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer">
                                              <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                                                  fill="#023047"
                                                ></path>
                                              </svg>
                                              Upload Photo
                                            </p>

                                            <input
                                              type="file"
                                              onChange={(e) =>
                                                handleSpeakerChange(
                                                  i,
                                                  index,
                                                  spindex,
                                                  "image",
                                                  e.target.files[0]
                                                )
                                              }
                                              class="d-none"
                                            />
                                          </label>
                                        </div>

                                        {speaker.image && (
                                          <div
                                            class="ct_single_uploaded_img mt-3 "
                                            style={{ height: "135px" }}
                                          >
                                            <img
                                              src={
                                                speaker.image
                                                  ? typeof speaker.image ===
                                                    "string"
                                                    ? speaker.image
                                                    : URL.createObjectURL(
                                                        speaker.image
                                                      )
                                                  : ""
                                              }
                                              alt=""
                                              className="w-100 h-100"
                                              style={{ borderRadius: "0px" }}
                                            />
                                            <i
                                              class="fa-solid fa-xmark"
                                              onClick={(e) =>
                                                handleSpeakerChange(
                                                  i,
                                                  index,
                                                  spindex,
                                                  "image",
                                                  null
                                                )
                                              }
                                            ></i>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              ))}
              <div class="d-flex align-items-center gap-3 justify-content-center pt-4">
                <button
                  class="ct_yellow_btn ct_outline_grey px-5 py-2"
                  type="button"
                  onClick={previousForm}
                >
                  Previous
                </button>
                <button
                  class="ct_sky_blue_btn ct_yellow_btn px-5 py-2"
                  type="button"
                  onClick={handleStep2}
                >
                  Continue
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateBootCampStep2;
